import React, { FC, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ThemeContext } from "@/context/data/ThemeContext";
import WebRoutes from "./WebRoutes";
import MobileRoutes from "./MobileRoutes";
import { useLang } from "@/hooks/useLang";

const MOBILE_PAGES = [
    "/admin/en/e-ticket/checkout-logs"
];

const AppRoutes: FC = () => {
    const { changeLanguageFromUrl } = useLang();
    const { currentTheme } = useContext(ThemeContext);
    const location = useLocation();

    useEffect(() => {
        changeLanguageFromUrl();
    }, []);

    const isMobilePage = currentTheme === "mobile" && MOBILE_PAGES.some(url => location.pathname.startsWith(url));

    return (
        <React.Fragment key={currentTheme}>
            {isMobilePage ? <MobileRoutes /> : <WebRoutes />}
        </React.Fragment>
    );
};

export default AppRoutes;
